import React from "react";

import styles from "./index.module.scss";
import { recordItem } from "../../../../types";
import { formatTimestamp } from "../../../../../../utils/common";
import moment from "moment";

interface PropsType {
  content: recordItem;
  firstItem: boolean;
  lastItem: boolean;
}

export default function ServiceProgressItem(props: PropsType) {
  const { content, firstItem, lastItem } = props;
  return (
    <div className={styles.progressWrapper}>
      <div className={`${styles.top} ${firstItem ? "" : styles.firstTop}`}>
        <h3>{content?.subOrderStatusText}</h3>
        {content?.phone && (
          <div className={styles.phone}>
            <a href={"tel:" + content?.phone}>联系司机</a>
          </div>
        )}
      </div>

      <div
        className={`${styles.contentArea} ${
          lastItem ? styles.lastContentArea : ""
        }`}
      >
        {content?.createTime && (
          <div className={styles.createTime}>
            {moment(content?.createTime).format("YYYY/MM/DD HH:mm")}
          </div>
        )}
        {content.tips && <div className={styles.tip}>{content.tips}</div>}
      </div>
    </div>
  );
}
